// extracted by mini-css-extract-plugin
export default {"root":"reset_root_XtuEc"};